import { render } from "./StockOrderApprovals.vue?vue&type=template&id=42e96fb8&scoped=true"
import script from "./StockOrderApprovals.vue?vue&type=script&lang=js"
export * from "./StockOrderApprovals.vue?vue&type=script&lang=js"

import "./StockOrderApprovals.vue?vue&type=style&index=0&id=42e96fb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e96fb8"]])

export default __exports__